import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = ({ onTakeSurvey }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          className={styles.headBg}
          src={getImageFromS3('images/25-sms-soho-rvmp/head-bg.png')}
          alt="head-bg"
        />
        <img
          className={styles.featuresBg}
          src={getImageFromS3('images/25-sms-soho-rvmp/features-bg.png')}
          alt="features-bg"
        />
        <img
          className={styles.buyBg}
          src={getImageFromS3('images/25-sms-soho-rvmp/buy-bg.png')}
          alt="buy-bg"
        />
        <div className={styles.headContainer}>
          <img
            className={styles.logo}
            src={getImageFromS3('images/25-sms-soho-rvmp/logo.png')}
            alt="logo"
          />
          <p className={styles.headTitle}>
            Незмінна якість
            <br />в оновленому дизайні
          </p>
          <img
            className={styles.packs}
            src={getImageFromS3('images/25-sms-soho-rvmp/packs.png')}
            alt="packs"
          />
        </div>
        <div className={styles.featuresContainer}>
          <div className={classNames(styles.featureRow, styles.featureRowPack)}>
            <img
              className={styles.featureIcon}
              src={getImageFromS3('images/25-sms-soho-rvmp/icon-pack.png')}
              alt="icon-pack"
            />
            <div className={styles.featureTextCol}>
              <p className={styles.featureTitle}>
                Оновлений дизайн
                <br />
                пачки
              </p>
            </div>
          </div>
          <div
            className={classNames(styles.featureRow, styles.featureRowFrame)}
          >
            <div className={styles.featureTextCol}>
              <p className={styles.featureTitle}>
                Оновлений дизайн внутрішньої рамки
              </p>
              <p className={styles.featureText}>
                А також QR-код всередині пачки
              </p>
            </div>
            <img
              className={styles.featureIcon}
              src={getImageFromS3('images/25-sms-soho-rvmp/icon-frame.png')}
              alt="icon-frame"
            />
          </div>
          {/*<div className={styles.disclaimer}>*/}
          {/*  *Змінюється лише дизайн пачки. Характеристики сигарет (фільтр, тютюн*/}
          {/*  та формат) залишаються незмінними.*/}
          {/*</div>*/}
          <div
            className={classNames(styles.featureRow, styles.featureRowFilter)}
          >
            <div className={styles.featureTextCol}>
              <p className={styles.featureTitle}>Recessed&trade; фільтр</p>
              <p className={styles.featureText}>
                Фільтр з повітряною камерою та вугільною частиною
              </p>
            </div>
            <img
              className={styles.featureIcon}
              src={getImageFromS3('images/25-sms-soho-rvmp/icon-filter.png')}
              alt="icon-filter"
            />
          </div>
          <div
            className={classNames(styles.featureRow, styles.featureRowTobacco)}
          >
            <img
              className={styles.featureIcon}
              src={getImageFromS3('images/25-sms-soho-rvmp/icon-tobacco.png')}
              alt="icon-tobacco"
            />
            <div className={styles.featureTextCol}>
              <p className={styles.featureTitle}>
                Тютюнова суміш
                <br />
                від Parliament
              </p>
            </div>
          </div>
        </div>
        <div className={styles.formatsContainer}>
          <p className={styles.formatsTitle}>
            Доступний у компактному та супертонкому форматах
          </p>
          <div className={styles.formatsBand}>
            <img
              src={getImageFromS3('images/25-sms-soho-rvmp/formats.png')}
              alt="formats"
            />
            <p className={classNames(styles.formatLabel, styles.formatLabelKs)}>
              King Size Slim
            </p>
            <p className={classNames(styles.formatLabel, styles.formatLabelSs)}>
              100 Super Slims
            </p>
          </div>
        </div>
        <div className={styles.surveyContainer}>
          <p className={styles.surveyTitle}>
            Хочеш отримувати новини про продукцію?
          </p>
          <p className={styles.surveyDescription}>
            Проходь невелике опитування та отримуй <b>30 грн</b> на мобільний за
            витрачений час.
          </p>
          <div className={styles.buttonContainer}>
            <button
              type="button"
              className={styles.buttonItem}
              onClick={onTakeSurvey}
            >
              <p>Пройти опитування</p>
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <div>
          <p>Куріння викликає серйозні захворювання та залежність</p>
          <p>Дана інформація про продукт надається відповідно</p>
          <p>до статті 15 Закону України «Про захист прав споживачів»</p>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
